// apps/merchant-v3/src/components/scope/NoTeamEmptyState.tsx
//
// Phase 6.1 Wave 5 Task 24 — dedicated empty state for a member with no
// team assignment (P6.1.D-28b, G-12, TS-12). Server returns 200 + empty
// data (fail-closed, never all — D-12); the FE swaps the whole page body
// for this state so KPI cards are hidden entirely (never shown as "0",
// which would read like the app is broken on first login).
//
// All copy flows through i18n (common namespace, 3 locales). No hardcoded
// strings.
//
// vg-binding: PLAN:task-24
// vg-binding: P6.1.D-28
// vg-binding: P6.1.D-02
// vg-binding: G-12
// vg-binding: G-36
// vg-binding: CONTEXT:decisions
// vg-binding: INTERFACE-STANDARDS:error-shape

import type { JSX } from 'react';
import { Users } from 'lucide-react';

import { useTranslation } from '@/lib/i18n';

export function NoTeamEmptyState(): JSX.Element {
  const { t } = useTranslation('common');

  return (
    <div
      data-testid="no-team-empty-state"
      className="flex min-h-[60vh] w-full flex-col items-center justify-center px-4 py-12 text-center"
    >
      <div className="mx-auto inline-flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-600">
        <Users className="h-8 w-8" aria-hidden />
      </div>
      <h1 className="mt-6 text-xl font-semibold text-pw-text">
        {t('scope.noTeam.title', {
          defaultValue: 'Bạn chưa được gán vào team',
        })}
      </h1>
      <p className="mt-3 max-w-md text-sm text-pw-text-muted">
        {t('scope.noTeam.body', {
          defaultValue:
            'Bạn chưa được gán vào team nào — liên hệ chủ shop để được cấp quyền truy cập cửa hàng.',
        })}
      </p>
    </div>
  );
}

export default NoTeamEmptyState;
